import { DEMONTE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';

export function filtrePatrimoineDispositifSansMaterielDemonte(dispositifs) {
  return dispositifs.map(dispositif => {
    const materielsActifs = (dispositif.materiels || []).filter(m => m.etat !== DEMONTE);
    return { ...dispositif, materiels: materielsActifs };
  });
}

export default function filtrePatrimoineEmplacementSansMaterielDemonte(emplacements) {
  return emplacements.map(emplacement => {
    return {
      ...emplacement,
      dispositifs: filtrePatrimoineDispositifSansMaterielDemonte(emplacement.dispositifs),
    };
  });
}
